import { observable } from "mobx";
import { request, apis } from '../../../utils/net';
import s from 'store';
import history from '../../../utils/history';
import Modal from 'antd/lib/modal';
import { message } from 'antd';
import moment from 'moment';

const store = observable({
    startTime: moment().startOf('month').unix(),         //起始时间戳
    endTime: moment().unix(),           //终止时间戳
    status: "",
    Page: 1,              ////表格参数
    Size: 10,
    Total: 0,
    DataSource: [],
    checkeds: [],
    printArr: [],        // 打印小票数组
    subAccountList:[],    //子账户列表
    samll_code_sn: '',
    code_store_id: '',
    code_drawer_id:'',

    // 插件打印
    pluginPrint(orderSn) {
        return request({
            url: apis.pluginPrint,
            method: 'post',
            data: {
                order_sn: orderSn
            }
        })
    },

    setFormData(form) {
        this.startTime = form.startTime
        this.endTime = form.endTime
        this.status = form.status
        this.samll_code_sn = form.samll_code_sn
        this.code_store_id = form.code_store_id
        this.code_drawer_id = form.code_drawer_id
    },

    search(page) {
        let obj = {
            page: page || store.Page,
            page_size: store.Size
        };
        obj.begin_at = store.startTime ? store.startTime : "";
        obj.end_at = store.endTime ? store.endTime : "";
        obj.status = store.status;
        obj.samll_code_sn = store.samll_code_sn;
        obj.code_store_id = store.code_store_id;
        obj.code_drawer_id = store.code_drawer_id;

        request({
            url: apis.getCodeOrderList,
            method: 'POST',
            data: obj,
            ext: {
                //没有权限，请先完成设置
                codes: ['2', '3', '4'],
                handle: (res) => {
                    let url = "/home";
                    if (res.code == "3") {
                        url = "/manage-center/menu-code/code-manage";
                    } else if (res.code == "4") {
                        url = "/home/sys-setup?edit=true";
                    }

                    Modal.warning({
                        title: '提示',
                        content: res.message,
                        onOk() {
                            history.push(url);
                        }
                    });
                }
            }
        }).then(res => {
            //     var res.list=[
            //     var list=[
            //         {id:1,c1:1519833600,c2:"FPE25R0201805051352200001",c3:100.00,c4:"0"},       //1:待审核    ---查看进度}
            //         {id:2,c1:1519833600,c2:"FPE25R0201805051352200001",c3:100.00,c4:"1"},         //2:待结算    ---发起结算}
            //         {id:22,c1:1519833600,c2:"FPE25R0201805051352200001",c3:100.00,c4:"0"},         //2:待结算    ---发起结算}
            //         {id:3,c1:1519833600,c2:"FPE25R0201805051352200001",c3:100.00,c4:"1"},         //3:待收款    ---查看进度}
            //         {id:4,c1:1519833600,c2:"FPE25R0201805051352200001",c3:100.00,c4:"1"},        //4:已完成    ---查看进度}
            //     ]
            store.Page = parseInt(res.page);
            store.Total = parseInt(res.total_count);
            store.DataSource = res.list;
        })
    },
    smTicketDetail: {},
    code_sn: 0,
    checkeds_code_sn: [],
    piliangStatue: false,
    getPrint(code_sn) {
        s.set("code_sn", "")
        s.set("piliangStatue", "")
        s.set("checkeds_code_sn", "")
        if (code_sn) {
            store.code_sn = code_sn;   //单个打印
            s.set("code_sn", code_sn)
            window.open("/#/external/print-ticket")
        } else {
            // console.log(store.checkeds_code_sn)
            s.set("piliangStatue", true)   //批量打印
            s.set("checkeds_code_sn", store.checkeds_code_sn)
            window.open("/#/external/print-ticket")
        }
    },
    Array_smTicketDetail: [],
    getModalData() {
        var code_sn = s.get("code_sn");
        var piliangStatue = s.get("piliangStatue");

        return new Promise((resolve) => {
            if (piliangStatue) {
                store.piliangStatue = true   //批量打印
                var Array = s.get("checkeds_code_sn");

                let i = 0;
                let len = Array.length;
                for (var item of Array) {
                    (function () {
                        request({
                            url: apis.smallInvoiceDetail,
                            method: 'post',
                            data: {
                                code_sn: item
                            },
                        }).then(res => {
                            store.Array_smTicketDetail.push(res);

                            i++;
                            if (i >= len) {
                                resolve(res);
                            }
                        })
                    })(item, i)
                }
            } else {
                store.piliangStatue = false   //单个打印
                request({
                    url: apis.smallInvoiceDetail,
                    method: 'post',
                    data: {
                        code_sn: code_sn
                    },
                }).then(res => {
                    store.smTicketDetail = res;

                    resolve(res);
                })
            }
        });
    },
    // ModalStatus:false,
    closeModal() {
        console.log(111)
        // store.ModalStatus = false
    },
    deleteId: "",
    showModal: false,
    showDeleteModal(id) {
        store.deleteId = id
        store.showModal = true
    },
    hideDeleteilModal() {
        request({
            url: apis.smallInvoiceDelete,
            method: 'post',
            data: {
                code_sn: store.deleteId
            },
        }).then(res => {
            store.showModal = false
            store.search(1);
        })
    },
    hideModal() {
        store.showModal = false
    },
    retryFP(order_sn) {
        request({
            url: apis.invoiceBlueRetryOne,
            method: 'post',
            data: {
                order_sn: order_sn
            },
        }).then(res => {
            console.log(res);
        })
    },

    // 获取子账户列表
    getSubAccount() {
        request({
            url: apis.subaccLists,
            method: 'GET',
        }).then(res => {
            this.subAccountList = [{
                nickname: '全部',
                id: ''
            }, ...res];
        });
    },

    // 小票作废
    getAddInvalid(code) {
        request({
            url: apis.addInvalid,
            method: 'post',
            data: {
                code_sn: code
            },
        }).then(res => {
            store.search(1);
            message.success('小票已作废成功');
        })
    },
})
export default store;
